import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddStudentComp from "./Component/AddStudentComp"


const AddStudent =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddStudentComp />
        </div>
        <Footer />
        </>
    )
}

export default AddStudent